/**
 * MatrixQuestionUI - 部門間マトリクスコンポーネント (モック_GB組織_回答画面_v1.html s7 準拠)
 * Part6用: 回答者の自部門以外の全部門を行として表示し、各部門毎に4段階で回答する。
 * 全部門の選択が完了すると「次へ」ボタンが活性化する。
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

/** 4段階の頻度ラベル (ほぼ毎日=1 〜 ほとんどなし=4 が記録値) */
const FREQUENCY_HEADER_LABELS = ['ほぼ\n毎日', '週に\n数回', '月に\n数回', 'ほとんど\nなし'];
const FREQUENCY_CELL_LABELS = ['毎日', '週数回', '月数回', 'なし'];

export interface MatrixDepartment {
  id: string;
  name: string;
}

interface MatrixQuestionUIProps {
  questionText: string;
  departments: MatrixDepartment[];
  /** departmentId → 1〜4 */
  values: Record<string, number>;
  onChange: (departmentId: string, value: number) => void;
  onNext: () => void;
  onBack: () => void;
  canGoBack: boolean;
}

export const MatrixQuestionUI: React.FC<MatrixQuestionUIProps> = ({
  questionText,
  departments,
  values,
  onChange,
  onNext,
  onBack,
  canGoBack,
}) => {
  const { t } = useTranslation();
  const allAnswered = departments.every((d) => values[d.id] != null);

  return (
    <>
      <h2 className="gb74-q-text">{questionText}</h2>
      <div className="gb74-matrix">
        <div className="gb74-matrix-header">
          <div className="gb74-matrix-space" />
          <div className="gb74-matrix-labels">
            {FREQUENCY_HEADER_LABELS.map((label) => (
              <span key={label}>{label}</span>
            ))}
          </div>
        </div>
        {departments.map((dept) => (
          <div key={dept.id} className="gb74-matrix-row">
            <div className="gb74-matrix-dept">{dept.name}</div>
            <div className="gb74-matrix-opts">
              {FREQUENCY_CELL_LABELS.map((label, idx) => {
                const value = idx + 1; // ほぼ毎日=1 〜 ほとんどなし=4
                const isSelected = values[dept.id] === value;
                return (
                  <button
                    key={value}
                    type="button"
                    className={`gb74-matrix-opt${isSelected ? ' sel' : ''}`}
                    onClick={() => onChange(dept.id, value)}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <button
        type="button"
        className="gb74-next-btn"
        disabled={!allAnswered}
        onClick={onNext}
      >
        {t('questionnaire.next', '次へ')}
      </button>
      {canGoBack && (
        <p className="gb74-back">
          <button type="button" onClick={onBack}>
            {t('questionnaire.previousQuestion')}
          </button>
        </p>
      )}
    </>
  );
};
